module.exports = __webpack_public_path__ + "static/media/welcome-bonus.96dd0ba0.png";